import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '🟢',
    title: 'Tomo 1 — ADMISIÓN, VÍNCULO Y PRIMERAS INTERVENCIONES CLÍNICAS',
    desc: 'Protocolo de admisión · Consentimiento informado · Encuadre terapéutico · Evaluación inicial · Primeras 8 sesiones · Perfil clínico integrado · Devolución diagnóstica · Derivaciones. Todos los perfiles · Adultos y adolescentes'
  }, {
    icon: '🟡',
    title: 'Tomo 2 — ANSIEDAD Y ESTRÉS',
    desc: '20+ técnicas de regulación fisiológica · Reestructuración cognitiva · Exposición gradual · Registro de pensamientos · Orientación al paciente · Articulación con psiquiatría · Planificador de 12 semanas. Adultos y adolescentes'
  }, {
    icon: '🟠',
    title: 'Tomo 3 — DEPRESIÓN Y ESTADO DE ÁNIMO',
    desc: 'Activación conductual · Reestructuración profunda · Autoregistros de ánimo · Trabajo con desesperanza · Evaluación de riesgo · Ruta de intervención paso a paso · Planificador de 16 semanas. Adultos y adolescentes'
  }, {
    icon: '🔴',
    title: 'Tomo 4 — VÍNCULOS Y PAREJA',
    desc: 'Teoría del apego aplicada · Comunicación asertiva · Límites saludables · Dependencia emocional · Celos y conflictos · Trabajo con rupturas y duelos vinculares · Planificador de 14 semanas. Adultos'
  }, {
    icon: '🟣',
    title: 'Tomo 5 — AUTOESTIMA Y CONSTRUCCIÓN DEL YO',
    desc: 'Autoconcepto · Voz crítica interna · Mandatos y vergüenza · Perfeccionismo · Autocompasión aplicada · Identidad y valores · Trabajo con vergüenza · Planificador de 14 semanas. Adultos y adolescentes'
  }, {
    icon: '⭐',
    title: 'Tomo 6 — CIERRE TERAPÉUTICO Y MANEJO DE CRISIS',
    desc: 'Alta y prevención de recaídas · Protocolo de riesgo suicida · Crisis en sesión · Abandono terapéutico · Derivaciones · Autocuidado de la psicóloga · Planificador de cierre. Todos los perfiles'
  }];
  const includes = ['Planificación mensual y trimestral lista para usar', '30-50 intervenciones clínicas con objetivo y registro', 'Protocolos de evaluación con fichas de seguimiento', 'Plantillas de informe listas para completar', 'Materiales imprimibles para usar en sesión', '100% adaptado a la psicóloga clínica argentina 2026'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-257">
      <div className="max-w-6xl mx-auto" data-id="element-258">
        <div className="text-center mb-12" data-id="element-259">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-260">
            <Book className="w-5 h-5" data-id="element-261" />
            <span data-id="element-262">EL SISTEMA</span>
          </div>
          <h2 className="md:text-5xl font-black mb-4 text-[28px]" data-id="element-263">
            ULTRAPACK PSICO PRO™
          </h2>
          <p className="text-brand font-bold mt-2" data-id="element-264">
            +480 páginas · 200+ intervenciones clínicas listas · Evaluaciones ·
            Informes · Protocolos · Derivaciones · Tareas para casa · Gestión ·
            Posicionamiento · Negocio.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center mt-[-30px]" data-id="element-265">
          📚 LOS 6 TOMOS — Para Psicólogas de todas las áreas clínicas
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-266">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-267">
              <div className="text-2xl mb-3" data-id="element-268">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-269">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-270">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto mt-[-25px] pt-[15px] pb-[15px] pl-[15px] pr-[15px] space-x-[12px] space-y-[16px]" data-id="element-271">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-272">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-273">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-274">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-275" />
                <span className="text-gray-300 text-[16px]" data-id="element-276">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}